/**
 * El mini-player de "Escuchar" DENTRO de la charla (lo monta `ConversationMobile`
 * justo debajo del header). Es el mismo `ListenMiniPlayer` que la barra global;
 * en `/conversation` la global se oculta y lo releva este.
 *
 * UN SOLO "CERRADO" PARA LOS DOS (2026-10-20, card #561). Hasta esa fecha la
 * charla llevaba su propio `miniClosed` local, ajeno al `dismissed` del
 * provider: el reproductor cerrado afuera reaparecía en cada charla, y el que
 * se cerraba en la charla volvía al salir a Inicio o Progreso. Ahora los dos
 * preguntan lo mismo (`useGlobalListenBarActive`) y cierran igual (`close`,
 * que pausa y descarta): cerrado queda cerrado en toda la app hasta que el
 * alumno vuelva a darle play a algo (el `play` del `<audio>` lo re-muestra).
 */

import { useListen } from './ListenProvider.js';
import { useGlobalListenBarActive } from './ListenContext.js';
import { ListenMiniPlayer } from './ListenMiniPlayer.js';

interface ConversationListenBarProps {
  /** Expandir → volver al player (la charla lo hace por `leave`). */
  onExpand: () => void;
}

export function ConversationListenBar({ onExpand }: ConversationListenBarProps) {
  const L = useListen();
  const active = useGlobalListenBarActive();
  if (!active) return null;
  return <ListenMiniPlayer onExpand={onExpand} onClose={L.close} />;
}
